import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPath2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "9.4191675mm",
	height: "11.90625mm",
	viewBox: "0 0 9.4191676 11.90625",
	id: "svg419",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			id: "namedview421",
			pagecolor: "#ffffff",
			bordercolor: "#000000",
			borderopacity: .25,
			"inkscape:showpageshadow": 2,
			"inkscape:pageopacity": 0,
			"inkscape:pagecheckerboard": 0,
			"inkscape:deskcolor": "#d1d1d1",
			"inkscape:document-units": "mm",
			showgrid: "false"
		}),
		/* @__PURE__ */ _jsx("defs", { id: "defs416" }),
		/* @__PURE__ */ _jsxs("g", {
			"inkscape:label": "Layer 1",
			"inkscape:groupmode": "layer",
			id: "layer1",
			transform: "translate(-39.681361,-142.54688)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "m 49.100528,148.47355 c 0,1.79916 -0.608542,3.22791 -1.825625,4.33916 -1.217084,1.08479 -2.8575,1.64042 -4.947709,1.64042 h -2.645833 v -2.32833 h 2.725208 c 1.27,0 2.275417,-0.3175 3.01625,-0.9525 0.767292,-0.66146 1.137709,-1.56105 1.137709,-2.69875 0,-1.13771 -0.370417,-2.01084 -1.164167,-2.64584 -0.767292,-0.635 -1.772708,-0.9525 -2.989792,-0.9525 h -2.725208 v -2.32833 h 2.69875 c 2.090208,0 3.730625,0.50271 4.92125,1.56104 1.190625,1.05833 1.799167,2.48708 1.799167,4.36563 z",
				id: "path2",
				"inkscape:export-filename": "../../../../../Downloads/path2.svg",
				"inkscape:export-xdpi": 96,
				"inkscape:export-ydpi": 96,
				style: { strokeWidth: .264583 }
			}), /* @__PURE__ */ _jsx("path", {
				d: "m 39.681361,147.30938 v 2.38125 h 3.571875 c 0.661458,0 1.190625,-0.52917 1.190625,-1.19063 v 0 c 0,-0.66145 -0.529167,-1.19062 -1.190625,-1.19062",
				id: "path14",
				style: { strokeWidth: .264583 }
			})]
		})
	]
});
export default SvgPath2;
